import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import LoginPage from '../pages/auth/LoginPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';
import DashboardPage from '../pages/dashboard/index';
import LeadManagement from '../pages/leads/index';
import FollowUpManagement from '../pages/followups/index';
import ReportsPage from '../pages/reports/index';
import CSVImportPage from '../pages/csv/index';
import UserManagement from '../pages/users/index';
import RoleManagement from '../pages/roles/index';
import CourseManagement from '../pages/courses/index';
import MasterData from '../pages/masters/index';
import NotificationsPage from '../pages/notifications/index';
import AuditLogs from '../pages/audit/index';
import IntegrationsPage from '../pages/integrations/index';
import LeadSyncControl from '../pages/lead-sync/index';
import TemplateManagement from '../pages/templates/index';
import BulkCampaignHistory from '../pages/bulk-campaigns/index';
import CounsellorView from '../pages/counsellors/index';

const AppRouter = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/" element={<AppLayout />}>
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="leads" element={<LeadManagement />} />
      <Route path="followups" element={<FollowUpManagement />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="csv" element={<CSVImportPage />} />
      <Route path="csv-import" element={<CSVImportPage />} />
      <Route path="users" element={<UserManagement />} />
      <Route path="roles" element={<RoleManagement />} />
      <Route path="courses" element={<CourseManagement />} />
      <Route path="masters" element={<MasterData />} />
      <Route path="notifications" element={<NotificationsPage />} />
      <Route path="audit" element={<AuditLogs />} />
      <Route path="integrations" element={<IntegrationsPage />} />
      <Route path="lead-sync" element={<LeadSyncControl />} />
      <Route path="templates" element={<TemplateManagement />} />
      <Route path="bulk-campaigns" element={<BulkCampaignHistory />} />
      <Route path="counsellors" element={<CounsellorView />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Route>
  </Routes>
);

export default AppRouter;
